// React and Hooks
import React, { useEffect, useRef, useState } from "react";

// Date-related
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker, DatePicker } from "@mui/x-date-pickers";
import Control from "react-leaflet-custom-control";

import { useLocation, useNavigate } from "react-router-dom";

// Styles and CSS

import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";

// MUI and Icons
import { GoLocation } from "react-icons/go";
import { FaCircle } from "react-icons/fa";
import { AiOutlineFileAdd } from "react-icons/ai";
import { MdCancel } from "react-icons/md";

// Bootstrap
import {
  Alert,
  Button,
  Col,
  Dropdown,
  Modal,
  NavDropdown,
  Offcanvas,
  OverlayTrigger,
  Row,
  Tab,
  Tabs,
  Tooltip,
  useAccordionButton,
} from "react-bootstrap";
import { MdDoubleArrow } from "react-icons/md";
// Leaflet and Map-related
import L from "leaflet";
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  Polygon,
  GeoJSON,
  LayersControl,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import * as turf from "@turf/turf";
import toGeoJSON from "@mapbox/togeojson";

// Utilities and Services
import axios from "axios";
import JSZip from "jszip";
import AuthService from "../../../services/auth.service";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import AuthServiceV3 from "../../../services/Operation.serviceV3.js";
import UserService from "../../../services/user.service";
import Static_modal from "../etc/Static_modal.js";
import { responsiveFontSizes } from "@mui/material";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png",
});

function JoinOperation() {
  const [sidebarMain, setSidebarMain] = useState(false); //
  const [displayPlans, setDisplayPlans] = useState(1); //
  const [createdPolygon, setCreatedPolygon] = useState([]); //
  const [showEstimateSuccess, setShowEstimateSuccess] = useState(false); //
  const [centerBetweenPolygon, setCenterBetweenPolygon] = useState([]);
  const [estimateSuccessStatus, setEstimateSuccessStatus] = useState({
    status: null,
    time: null,
  }); //
  const [estimateID, setEstimateID] = useState("");
  let Navigate = useNavigate();
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };

  const [operationCode, setOperationCode] = useState("");

  const [showSuccess, setShowSuccess] = useState(false);
  const [showSendcoop, setShowSendcoop] = useState(false);
  const [showSend, setShowSend] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showErroroperation, setShowErroroperation] = useState(false);
  const [showAgreement, setShowAgreement] = useState(false);
  const [chosenForm, setChosenForm] = useState(1);
  const [agreementPage, setAgreementPage] = useState(1);
  const [populationShow, setPopulationShow] = useState(true);

  const presentTime = dayjs(new Date());
  const desiredLimit = dayjs(new Date() - 1 * 24 * 60 * 60 * 1000);
  const [dayTimeStart, setDayTimeStart] = useState(
    dayjs(new Date()).add(1, "hour")
  );
  const [dayTimeEnd, setDayTimeEnd] = useState(
    dayjs(new Date(timeStringToInt(dayTimeStart) + 600000))
  );

  const [coopStartTime, setCoopStartTime] = useState("");
  const [coopEndTime, setCoopEndTime] = useState("");

  const [selectedPilot, setSelectedPilot] = useState("");
  const [chosenHeight, setChosenHeight] = useState([90, 90, 90]);
  const [isTimeBeingSet, setIsTimeBeingSet] = useState(false);
  const [availablePilot, setAvailablePilot] = useState([]);
  const [availableDrone, setAvailableDrone] = useState([]);
  const [availableDroneID, setAvailableDroneID] = useState("");

  const [dropDownID, setDropDownID] = useState();
  const [selectedDrone, setselectedDrone] = useState("");

  const [filename, setFilename] = useState(undefined);

  const [specificData, setSpecificData] = useState([]);
  const mapRef = useRef();
  const [availablePurpose, setAvailablePurpose] = useState([]);
  const [fetchedPurpose, setFetchedPurpose] = useState([]);
  const [selectedPurpose, setSelectedPurpose] = useState(1);
  const [selectedPurposeText, setSelectedPurposeText] = useState([]);
  const [ninetyHeight, setNinetyHeight] = useState(false);
  const [cooperative, setCooperative] = useState(false);
  const [coopUnit, setCoopUnit] = useState("");
  const [searchCoop, setSearhCoop] = useState(false);
  const [CoopId, setCoopId] = useState("");
  const [operationArea, setOperationArea] = useState([]);
  const [operationPurpose, setOperationPurpose] = useState("");
  const [isCoopFound, setIsCoopFound] = useState(false);
  const [searchcheck, setSearchcheck] = useState(0);
  const [estimatedInfo, setEstimatedInfo] = useState([]);
  const [isEstimateAble, setIsEstimatable] = useState(true);
  const [prohibitPolygon, setProhibitPolygon] = useState([]);
  const [allReservedArea, setAllReservedArea] = useState([]);
  const [timedReservedArea, setTimedReservedArea] = useState([]);
  const [thailandProvince, setThailandProvince] = useState();
  const [PDRArea, setPDRArea] = useState();
  const [Aerodrome, setAeroDrome] = useState();
  const [hospital, setHospital] = useState();
  const [govOffice, setGovOffice] = useState();
  const [thaiGov, setThaiGov] = useState();
  const [embassy, setEmbassy] = useState();
  const [bangkokPopulation, setBangkokPopulation] = useState();
  const [policeDepartment, setPoliceDepartment] = useState();
  const [prohibitedAres, setProhibitedAres] = useState();
  const [restrictedAreas, setRestrictedAreas] = useState();
  const [dangerAreas, setDangerAres] = useState();
  const [confirmSend, setConfirmSend] = useState(false);
  const agreementContent = [
    {
      text: "สถานที่ที่จะปฏิบัติการบิน: (คำอธิบายรายละเอียดของตำแหน่งที่ปฏิบัติการบิน หรือขอบเขตของพื้นทีปฏิบัติการอาจจะต้องจัดเตรียมซึ่งอาจระบุไว้ในพิกัดละติจูดและลองจิจูด)",
      status: "-",
    },
    {
      text: "วันและเวลาที่เสนอเพื่อปฏิบัติการบิน (สูงสุด 5 คืน ภายในหนึ่งเดือนตามปฏิทิน)",
      status: "-",
    },
    {
      text: "ระบบเพื่อความปลอดภัยในการบิน ได้แก่ ระบบบันทึกการบิน (Flight Log) และระบบรับรู้ทางภูมิศาสตร์(Geo-Awareness)",
      status: "-",
    },
    {
      text: "ไฟแสดงตำแหน่ง (Navigation Lighting) และควรติดตั้งระบบไฟป้องกันการชน (Strobe or Anti-CollisionLight)",
      status: "-",
    },
    {
      text: "สถานีภาคพื้น (Ground Station)ควบคุม (Remote Controller Software) จะต้องสามารถระบุตำแหน่งของอากาศยานที่เป็นปัจจุบันให้กับนักบินทราบได้หรือซอฟต์แวร์ของชุด",
      status: "-",
    },
    {
      text: "สถานีภาคพื้น (Ground Station)หรือซอฟต์แวร์ของชุดควบคุม (Remote Controller Software) จะต้องสามารถระบุตำแหน่งของอากาศยานที่เป็นปัจจุบันให้กับนักบินทราบได้",
      status: "-",
    },
    {
      text: "ระบบป้องกันการชนและการหลบหลีกสิ่งกีดขวาง",
      status: "-",
    },
    {
      text: "ชุดอุปกรณ์ด้านความปลอดภัย ได้แก่ ชุดสะท้อนแสงรองเท้านิรภัย สำหรับนักบิน บุคลากรและเจ้าหน้าที่ที่เกี่ยวข้องกับการปฏิบัติการบิน",
      status: "-",
    },
    {
      text: "นักบินมีความรู้เกี่ยวกับกฎหมาย กฎระเบียบ ที่เกี่ยวข้องกับอากาศยานซึ่งไม่มีนักบิน และมีความรู้ความชำนาญในการบังคับอากาศยานและใช้ระบบของอากาศยานที่ใช้ในการปฏิบัติการบิน",
      status: "-",
    },
    {
      text: "มีผู้ช่วยสังเกตการบิน (Visual Observer, VO) ซึ่งนักบินรับรองว่าเป็นผู้มีความสามารถปฏิบัติการบินดังกล่าว",
      status: "-",
    },
    {
      text: "มีการสื่อสารที่มีประสิทธิภาพระหว่างนักบิน และผู้ช่วยสังเกตการบินตลอดระยะเวลาในการปฏิบัติการบิน",
      status: "-",
    },
    {
      text: "มีการทำประกันภัยสำหรับความเสียหายอันเกิดแก่ร่างกาย ชีวิต ตลอดจนทรัพย์สินของบุคคลที่สามวงเงินประกันไม่ต่ำกว่าหนึ่งล้านบาทต่อครั้ง",
      status: "-",
    },
    {
      text: "นักบิน และ/หรือ ผู้ช่วยสังเกตการบิน สามารถมองเห็นห้วงอากาศรอบข้างได้ตลอดเวลาปฏิบัติการบิน",
      status: "-",
    },
    {
      text: `นักบินต้องรักษาการสื่อสารที่มีประสิทธิภาพกับผู้ช่วยสังเกตการบิน เพื่อให้ทราบตำแหน่ง ระดับความสูง ท่าทางการบิน 
      และตำแหน่งของอากาศยานอย่างต่อเนื่อง รวมถึงข้อมูลสิ่งกีดขวาง เพื่อหลีกเลี่ยงการชนกันเพื่อความปลอดภัยในการปฏิบัติการบิน`,
      status: "-",
    },
    {
      text: "ผู้ช่วยสังเกตการบินแต่ละคนจะต้องไม่สังเกตการอาากศยานมากกว่า 1 ลำหรือช่วยสนับสนุนนักบินมากกว่าหนึ่งคนในเวลาเดียวกัน และไม่ควรได้รับมอบหมายหน้าที่อื่นๆ พร้อมกัน",
      status: "-",
    },
    {
      text: `ทำการสำรวจพื้นที่ปฏิบัติการและประเมินด้านความปลอดภัย (Conduct site and Flight safety assessment)ในเวลากลางวัน 
      เพื่อให้ทราบสภาพสถานที่ และแนวทางที่เหมาะสมในการปฏิบัติการบินรวมถึงกรอกแบบฟอร์มการสำรวจพื้นที่และแบบฟอร์มที่เกี่ยวข้องให้ครบถ้วน`,
      status: "-",
    },
    {
      text: `จุดบินขึ้นและลง (รวมถึงจุดลงจอดฉุกเฉิน) จะต้องมี แสงสว่างเพียงพอเพื่อให้การมองเห็นที่ชัดเจน 
      เพื่อความปลอดภัยและการอํานวยความสะดวกในการขึ้นและลงของอากาศยาน และป้องกันบุคคลไม่เกี่ยวข้อง เข้ามาในพื้นที่บินขึ้นลง`,
      status: "-",
    },
    {
      text: `จุดบินขึ้นและลง (รวมถึงจุดลงจอดฉุกเฉิน) จะต้องมี แสงสว่างเพียงพอเพื่อให้การมองเห็นที่ชัดเจน 
      เพื่อความปลอดภัยและการอํานวยความสะดวกในการขึ้นและลงของอากาศยาน และป้องกันบุคคลไม่เกี่ยวข้อง เข้ามาในพื้นที่บินขึ้นลง`,
      status: "-",
    },
    {
      text: "นักบินจะต้องได้รับข้อมูลที่เกี่ยวข้อง ได้แก่ ทัศนวิสัย ภาคพื้นดิน ฐานเมฆ ความเร็วลม และปริมาณน้ําฝน ของพื้นที่ปฏิบัติการบินจากกรมอุตุนิยมวิทยา",
      status: "-",
    },
    {
      text: "ไม่ปฏิบัติการบินในพื้นที่หวงห้ามเฉพาะ พื้นที่หวงห้าม เด็ดขาด หรือพื้นที่อันตราย และไม่ทําการบรรทุกวัตถุอันตราย",
      status: "-",
    },
    {
      text: `ต้องปฏิบัติตามข้อกําหนดอื่น ได้แก่ \n
      1.)ปฏิบัติการบินในระยะสายตา \n
      2.)ใช้ระดับความสูงไม่เกิน 300 ฟุต \n
      3.)รักษาระยะห่างด้านข้างกับบุคคล ยานพาหนะ หรือ โครงสร้างที่ไม่เกี่ยวข้องใด ๆ \n
      4.)ไม่ปฏิบัติการบินบรรทุกคน หรือสัตว์ \n
      5.)ไม่ปฏิบัติการบินทิ้งสิ่งของจากอากาศยาน \n
      6.)ไม่ปฏิบัติการบินอากาศยานมากกว่า 1 ลํา ในเวลา เดียวกัน`,
      status: "-",
    },
    {
      text: "บริเวณภาคพื้นดิน สามารถมองเห็นได้ชัดเจน โดย นักบิน ผู้ช่วยสังเกตการบิน และ/หรือพนักงาน สนับสนุน เพื่อให้การบังคับและมองเห็น อากาศยานเป็นไปอย่างมีประสิทธิภาพ",
      status: "-",
    },
    {
      text: "ไม่ปฏิบัติการบินเข้าไปในเมฆ",
      status: "-",
    },
    {
      text: "นักบินต้องสามารถทราบความเร็วลม บริเวณพื้นผิว ของพื้นที่ที่จะปฏิบัติการบินและความเร็วลมไม่เกินกว่าที่บริษัทผู้ผลิตอากาศยานกําาหนด",
      status: "-",
    },
    {
      text: `นักบินจะต้องมีขั้นตอนปฏิบัติที่เหมาะสม และมีกลไก ป้องกันด้านความปลอดภัย (Fail-Safe Mechanism) สําหรับกรณีฉุกเฉินระหว่างการปฏิบัติการบิน 
      เช่นการสูญเสียค่าสั่งควบคุม (Loss of Command) และการ เชื่อมโยงการควบคุม (Control Link) การสูญเสียอุปก รณ์น้าทาง (Loss of Navigation Light)`,
      status: "-",
    },
    {
      text: "กรณีเกิดอุบัติเหตุ ซึ่งมีบุคคลบาดเจ็บหรือทรัพย์สินเกิด ความเสียหาย ให้แจ้งตํารวจ และรายงานฝ่ายมาตรฐานอากาศยานซึ่งไม่มีนักบิน ที่uas ur@caat.or.th โดยเร็วทั้งนี้ไม่เกิน 24 ชั่วโมงนับจากเกิดเหตุ",
      status: "-",
    },
    {
      text: `ผู้ได้รับอนุญาตจะต้องให้รายละเอียดเพิ่มเติม และ/หรือ ผลการสอบสวนภายใน 3 วัน 
      โดยเป็นลายลักษณ์ อักษรทางอีเมล์ที บอร ur@caat.or.th บันทึก เหตุการณ์ ทั้งหมดจะต้องได้รับเก็บการดูแลอย่างเหมาะสม`,
      status: "-",
    },
    {
      text: `ไฟแสดงตําแหน่ง (Navigation Lighting) ต้องเปิดอยู่ ตลอดเวลาในขณะปฏิบัติการบิน เพื่อให้นักบิน และ/หรือผู้ช่วยสังเกตการบินสามารถมองเห็นระบุ คําแหน่ง ทิศทาง ของอากาศยาน`,
      status: "-",
    },
    {
      text: `ก่อนขึ้นปฏิบัติการบิน อากาศยานจะต้องสามารถ เชื่อมต่อสัญญาณดาวเทียมได้ (Achieve a Positive Satellite Lock) อย่างน้อย 7 ดวง`,
      status: "-",
    },
    {
      text: `นักบินจะต้องมีขั้นตอนปฏิบัติที่เหมาะสม และมีกลไกป้องกันความไม่ปลอดภัย (Fail-Safe Mechanism) 
      สําหรับกรณีฉุกเฉินระหว่างการปฏิบัติการบิน เช่นการ สูญเสียค่าสั่งควบคุม (Loss of Command) และ เชื่อมต่อ (Control Link) การสูญเสียไฟนําทาง (Loss of Navigation Light)`,
      status: "-",
    },
    {
      text: `ซอฟต์แวร์ของชุดควบคุม (Remote Controller Software)จะต้องสามารถระบุตําแหน่งของอากาศยานที่เป็นปัจจุบันได้`,
      status: "-",
    },
    {
      text: `มีผู้ช่วยสังเกตการบิน (Visual Observer)`,
      status: "-",
    },
  ];

  // ██╗███╗░░██╗██╗████████╗██╗░█████╗░████████╗███████╗  ██████╗░░█████╗░████████╗░█████╗░
  // ██║████╗░██║██║╚══██╔══╝██║██╔══██╗╚══██╔══╝██╔════╝  ██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗
  // ██║██╔██╗██║██║░░░██║░░░██║███████║░░░██║░░░█████╗░░  ██║░░██║███████║░░░██║░░░███████║
  // ██║██║╚████║██║░░░██║░░░██║██╔══██║░░░██║░░░██╔══╝░░  ██║░░██║██╔══██║░░░██║░░░██╔══██║
  // ██║██║░╚███║██║░░░██║░░░██║██║░░██║░░░██║░░░███████╗  ██████╔╝██║░░██║░░░██║░░░██║░░██║
  // ╚═╝╚═╝░░╚══╝╚═╝░░░╚═╝░░░╚═╝╚═╝░░╚═╝░░░╚═╝░░░╚══════╝  ╚═════╝░╚═╝░░╚═╝░░░╚═╝░░░╚═╝░░╚═╝

  const checkOperator = () => {
    const operatorid = sessionStorage.getItem("operator_id");
    if (operatorid === "null" || operatorid === undefined) {
      setShowErroroperation(true);
      setTimeout(() => {
        setShowErroroperation(false);
        Navigate("/user/drone/statusDrone");
      }, 2000);
    } else {
      const check = AuthServiceV2.NewToken()
      .then()
      .catch((error) => {
        // setTextBody(error);
        // setModalToggle({ ...modalToggle, modalErr: true });
        console.log(error)
      });
    }
  };

  const getPurposes = () => {
    const purposeList = AuthServiceV2.DronePurposes();
    if (purposeList) {
      purposeList
        .then((response) => {
          const responseData = response.data.data;
          setFetchedPurpose(responseData);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    checkOperator();
    getPurposes();
  }, []);

  // ██╗░░░░░░█████╗░░█████╗░░█████╗░████████╗███████╗  ███╗░░░███╗███████╗
  // ██║░░░░░██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝  ████╗░████║██╔════╝
  // ██║░░░░░██║░░██║██║░░╚═╝███████║░░░██║░░░█████╗░░  ██╔████╔██║█████╗░░
  // ██║░░░░░██║░░██║██║░░██╗██╔══██║░░░██║░░░██╔══╝░░  ██║╚██╔╝██║██╔══╝░░
  // ███████╗╚█████╔╝╚█████╔╝██║░░██║░░░██║░░░███████╗  ██║░╚═╝░██║███████╗
  // ╚══════╝░╚════╝░░╚════╝░╚═╝░░╚═╝░░░╚═╝░░░╚══════╝  ╚═╝░░░░░╚═╝╚══════╝

  const showMyLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (mapRef.current) {
            mapRef.current.flyTo(
              [position.coords.latitude, position.coords.longitude],
              17,
              {
                animate: true,
              }
            );
          }
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    }

    if (mapRef.current) {
      mapRef.current.flyTo([13.102617437258145, 100.88806223049966], 15, {
        animate: true,
      });
    }
  };

  const flyToCoopArea = (position) => {
    const center = turf.centroid(turf.polygon([position]));
    mapRef.current.flyTo(center.geometry.coordinates, 15, {
      animate: true,
    });
  };

  // ██████╗░░█████╗░██╗░░░░░██╗░░░██╗░██████╗░░█████╗░███╗░░██╗  ░█████╗░██████╗░██████╗░░█████╗░██╗░░░██╗
  // ██╔══██╗██╔══██╗██║░░░░░╚██╗░██╔╝██╔════╝░██╔══██╗████╗░██║  ██╔══██╗██╔══██╗██╔══██╗██╔══██╗╚██╗░██╔╝
  // ██████╔╝██║░░██║██║░░░░░░╚████╔╝░██║░░██╗░██║░░██║██╔██╗██║  ███████║██████╔╝██████╔╝███████║░╚████╔╝░
  // ██╔═══╝░██║░░██║██║░░░░░░░╚██╔╝░░██║░░╚██╗██║░░██║██║╚████║  ██╔══██║██╔══██╗██╔══██╗██╔══██║░░╚██╔╝░░
  // ██║░░░░░╚█████╔╝███████╗░░░██║░░░╚██████╔╝╚█████╔╝██║░╚███║  ██║░░██║██║░░██║██║░░██║██║░░██║░░░██║░░░
  // ╚═╝░░░░░░╚════╝░╚══════╝░░░╚═╝░░░░╚═════╝░░╚════╝░╚═╝░░╚══╝  ╚═╝░░╚═╝╚═╝░░╚═╝╚═╝░░╚═╝╚═╝░░╚═╝░░░╚═╝░░░

  // ███╗░░░███╗░█████╗░███╗░░██╗░█████╗░░██████╗░███████╗███╗░░░███╗███████╗███╗░░██╗████████╗
  // ████╗░████║██╔══██╗████╗░██║██╔══██╗██╔════╝░██╔════╝████╗░████║██╔════╝████╗░██║╚══██╔══╝
  // ██╔████╔██║███████║██╔██╗██║███████║██║░░██╗░█████╗░░██╔████╔██║█████╗░░██╔██╗██║░░░██║░░░
  // ██║╚██╔╝██║██╔══██║██║╚████║██╔══██║██║░░╚██╗██╔══╝░░██║╚██╔╝██║██╔══╝░░██║╚████║░░░██║░░░
  // ██║░╚═╝░██║██║░░██║██║░╚███║██║░░██║╚██████╔╝███████╗██║░╚═╝░██║███████╗██║░╚███║░░░██║░░░
  // ╚═╝░░░░░╚═╝╚═╝░░╚═╝╚═╝░░╚══╝╚═╝░░╚═╝░╚═════╝░╚══════╝╚═╝░░░░░╚═╝╚══════╝╚═╝░░╚══╝░░░╚═╝░░░

  function normalSwapLatLon(arr) {
    const tempArray = [];
    if (arr.length > 0) {
      const swappedArray = arr.map((subArr) => {
        return [subArr[1], subArr[0]];
      });
      tempArray.push(swappedArray);
    }
    return tempArray;
  }

  // ██╗░░██╗░█████╗░███╗░░██╗██████╗░██╗░░░░░███████╗  ████████╗██╗███╗░░░███╗███████╗
  // ██║░░██║██╔══██╗████╗░██║██╔══██╗██║░░░░░██╔════╝  ╚══██╔══╝██║████╗░████║██╔════╝
  // ███████║███████║██╔██╗██║██║░░██║██║░░░░░█████╗░░  ░░░██║░░░██║██╔████╔██║█████╗░░
  // ██╔══██║██╔══██║██║╚████║██║░░██║██║░░░░░██╔══╝░░  ░░░██║░░░██║██║╚██╔╝██║██╔══╝░░
  // ██║░░██║██║░░██║██║░╚███║██████╔╝███████╗███████╗  ░░░██║░░░██║██║░╚═╝░██║███████╗
  // ╚═╝░░╚═╝╚═╝░░╚═╝╚═╝░░╚══╝╚═════╝░╚══════╝╚══════╝  ░░░╚═╝░░░╚═╝╚═╝░░░░░╚═╝╚══════╝

  function timeStringToInt(time) {
    const date = new Date(time);
    return Math.round(date.getTime());
  }

  const convertTime = (dateTimeString) => {
    let dateAndTimeParts = dateTimeString.split("T");
    let datePart = dateAndTimeParts[0];
    let timePart = dateAndTimeParts[1].split("+")[0];
    let [hours, minutes] = timePart.split(":").slice(0, 2);
    let formattedDateTime = `${datePart} ${hours}:${minutes}`;
    return formattedDateTime;
  };

  function formattingDate(inputDate) {
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");

    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:00+07:00`;
    return formattedDate;
  }

  const doSearchCooperative = () => {
    findOperation();
    if (searchCoop === true) {
      setSearhCoop(false);
    } else {
      setSearhCoop(true);
    }
  };

  const getOperationAreaData = () => {
    const dataArea = AuthServiceV2.Opearationdata();
    if (dataArea) {
      dataArea
        .then((response) => {
          const responseData = response.data;
          const allAreaData = [];
          if (responseData != undefined) {
            if (
              responseData.agency_data.length > 0 ||
              responseData.agency_data.length !== undefined
            ) {
              for (let i = 0; i < responseData.agency_data.length; i++) {
                const TempAreaData = [];

                const agencyArea =
                  responseData.agency_data[i].operation_area.Volume3D
                    .outline_polygon.vertices;
                for (let j = 0; j < agencyArea.length; j++) {
                  TempAreaData.push([agencyArea[j].Lon, agencyArea[j].Lat]);
                }

                allAreaData.push({
                  start_time: new Date(
                    responseData.agency_data[i].start_time
                  ).getTime(),
                  end_time: new Date(
                    responseData.agency_data[i].end_time
                  ).getTime(),
                  operation_area: TempAreaData,
                  type: `${
                    responseData.agency_data[i].operation_type.split("-")[0]
                  }`,
                });
              }
            }
            for (let i = 0; i < responseData.operator_data.length; i++) {
              const TempAreaData = [];
              if (
                responseData.operator_data[i].operation_status ===
                "หน่วยงานยกเลิกภารกิจ"
              ) {
                setIsEstimatable(false);
              }

              const operatorData =
                responseData.operator_data[i].operation_area.Volume3D
                  .outline_polygon.vertices;

              for (let j = 0; j < operatorData.length; j++) {
                TempAreaData.push([operatorData[j].Lon, operatorData[j].Lat]);
              }

              allAreaData.push({
                start_time: new Date(
                  responseData.operator_data[i].start_time
                ).getTime(),
                end_time: new Date(
                  responseData.operator_data[i].end_time
                ).getTime(),
                operation_area: TempAreaData,
                type: `${
                  responseData.operator_data[i].operation_type.split("-")[0]
                }`,
              });
            }
            setAllReservedArea(allAreaData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const legendPopulation = [
    { population: "น้อยกว่า 1000", color: 0.1 },
    { population: "1000-2499", color: 0.2 },
    { population: "2500-4999", color: 0.3 },
    { population: "5000-7499", color: 0.3 },
    { population: "7500-9999", color: 0.5 },
    { population: "10000-14999", color: 0.6 },
    { population: "15000-19999", color: 0.7 },
    { population: "20000-24999", color: 0.8 },
    { population: "มากกว่า 24999", color: 0.9 },
  ];

  const getAvailableInformation = (startDate, endDate) => {
    const droneAndPilotData = AuthServiceV3.DroneAndPilotData(
      startDate,
      endDate
    );
    if (!droneAndPilotData) return;
    droneAndPilotData
      .then((response) => {
        if (response.data.error_description === undefined) {
          const { dropdown_id, drone_data, pilot_data } = response.data;
          setDropDownID(dropdown_id);
          const droneElement = drone_data.map(
            (drone) => `${drone.drone_id} - ${drone.brand_model}`
          );
          const purposeElement = drone_data.reduce(
            (acc, drone) => ({ ...acc, [drone.drone_id]: drone.purpose }),
            {}
          );

          const pilotElement = pilot_data.map(
            (pilot) => `${pilot.co_id}-${pilot.pilot_name}-${pilot.pilot_type}`
          );

          setAvailableDrone(droneElement);
          setAvailablePurpose(purposeElement);
          setAvailablePilot(pilotElement);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const confirmSendInfo = () => {
    let confirmInfo = AuthServiceV3.ComfirmOperation(estimateID);
    if (confirmInfo != null) {
      confirmInfo.then((response) => {});
    }
  };

  useEffect(() => {
    setSidebarMain(true);
    async function fetchData() {
      try {
        const [
          responsePDRArea,
          responseAeroDrome,
          responseHospital,
          responseGovOffice,
          responseEmbassy,
          responsePoliceDepartment,
          responseThaiGov,
          allGeoData,
          responseBangkokPopulation,
        ] = await Promise.all([
          axios.get("../../PDR-AREA.geojson"),
          axios.get("../../Aerodrome.geojson"),
          axios.get("../../hospitalLocation.geojson"),
          axios.get("../../GovOfficetoutput.geojson"),
          axios.get("../../Embassyoutput.geojson"),
          axios.get("../../PoliceDepartmentoutput.geojson"),
          axios.get("../../ThaiGovoutput.geojson"),
          AuthServiceV2.AllGeoFenceData().then((res) => {
            return res;
          }),
          axios.get("../../BKK_District.geojson"),
        ]);
        let PDRDataset = {
          type: "FeatureCollection",

          features: [
            ...allGeoData.data.prohibited_areas.features,
            ...allGeoData.data.danger_areas.features,
            ...allGeoData.data.restricted_areas.features,
          ],
        };
        setProhibitedAres(allGeoData.data.prohibited_areas.features);
        setRestrictedAreas(allGeoData.data.restricted_areas.features);
        setDangerAres(allGeoData.data.danger_areas.features);
        setPDRArea(PDRDataset);
        setAeroDrome(allGeoData.data.aerodrome.features);

        setHospital(responseHospital.data);

        setGovOffice(responseGovOffice.data);

        setThaiGov(responseThaiGov.data);

        setPoliceDepartment(responsePoliceDepartment.data);

        setEmbassy(responseEmbassy.data);
        setBangkokPopulation(responseBangkokPopulation.data);
        // ////(responseEmbassy.data);
        // // //("responseEmbassy", responseEmbassy.data);

        const tempAllData = [
          ...allGeoData.data.aerodrome.features.map((feature) => ({
            area: feature.geometry.coordinates[0][0],
            name: feature.properties.province,
          })),
          ...allGeoData.data.danger_areas.features.map((feature) => ({
            area: feature.geometry.coordinates[0][0],
            name: feature.properties.name,
          })),
          ...allGeoData.data.other_areas.features.map((feature) => ({
            area: feature.geometry.coordinates[0][0],
            name: feature,
          })),
          ...allGeoData.data.prohibited_areas.features.map((feature) => ({
            area: feature.geometry.coordinates[0][0],
            name: feature.properties.name,
          })),
          ...allGeoData.data.restricted_areas.features.map((feature) => ({
            area: feature.geometry.coordinates[0][0],
            name: feature.properties.name,
          })),
          ...responseHospital.data.features.map((feature) => ({
            area: feature.geometry.coordinates[0],
            name: feature.properties.Agency,
          })),
          ...responseGovOffice.data.features.map((feature) => ({
            area: feature.geometry.coordinates[0],
            name: feature.properties.name,
          })),
          ...responseEmbassy.data.features.map((feature) => ({
            area: feature.geometry.coordinates[0],
            name: feature.properties.name_t,
          })),
          ...responsePoliceDepartment.data.features.map((feature) => ({
            area: feature.geometry.coordinates[0],
            name: feature.properties.name,
          })),
          ...responseThaiGov.data.features.map((feature) => ({
            area: feature.geometry.coordinates[0],
            name: feature.properties.name,
          })),
        ];
        setProhibitPolygon(tempAllData);
      } catch (error) {
        console.error("Error fetching JSON data:", error);
      }
    }
    fetchData();
    // setTimeout(() => {
    //   getAvailableInformation();
    //   getOperationAreaData();
    // }, 1000);
  }, []);

  const bangkokPopulationColorized = (feature) => {
    const population = feature.properties.DN;
    return {
      fillColor: "red", // Set colors based on categories
      color: "transparent",

      fillOpacity:
        population < 1000
          ? 0.1
          : population >= 1000 && population < 2500
          ? 0.2
          : population >= 2500 && population < 5000
          ? 0.3
          : population >= 5000 && population < 7500
          ? 0.4
          : population >= 7500 && population < 10000
          ? 0.5
          : population >= 10000 && population < 15000
          ? 0.6
          : population >= 15000 && population < 20000
          ? 0.7
          : population >= 20000 && population < 25000
          ? 0.8
          : 0.9,
    };
  };

  const findOperation = () => {
    let check = AuthServiceV3.FindAgencyOperation(operationCode);
    if (check != null)
      check
        .then((res) => {
          console.log("Response :", res.data);
          if (
            res.data.operation_area != undefined ||
            res.data.operation_area != null
          ) {
            const polygonArray =
              res.data.operation_area.Volume3D.outline_polygon.vertices;
            const swappedCoordinatesArray = polygonArray.map((subArray) => [
              subArray.Lat,
              subArray.Lon,
            ]);
            flyToCoopArea(swappedCoordinatesArray);
            setOperationArea(swappedCoordinatesArray);
            setOperationPurpose(res.data.purpose);
            setCoopStartTime(convertTime(res.data.start_time));
            setCoopEndTime(convertTime(res.data.end_time));
            getAvailableInformation(res.data.start_time, res.data.end_time);
            setIsCoopFound(true);
          } else {
            setOperationArea([]);
            setOperationPurpose("");
            setIsCoopFound(false);
            setCoopStartTime("");
            setCoopEndTime("");
          }
        })
        .catch((error) => {
          switch (error) {
            case "Operation not found":
              setTextBody("ไม่พบรหัสปฏิบัติการ");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            case "Operation code is required":
              setTextBody("กรุณากรอกรหัสปฏิบัติการ");
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
            default:
              setTextBody(error);
              setModalToggle({ ...modalToggle, modalErr: true });
              break;
          }
        });
  };

  const joinOperation = () => {
    let tempErrorMessage = "";
    if (typeof selectedDrone !== "string" || !selectedDrone.includes("-")) {
      return null;
    }
    const selectedDroneID = parseInt(selectedDrone.split("-")[0].trim());
    console.log("Run Func")
    AuthServiceV3.JoinOperation(
      operationCode,
      dropDownID,
      parseInt(selectedPilot.split("-")[0]),
      selectedDroneID
    ).then((response) => {
      console.log(response)
      if (response.data.status !== "error") {
        setModalToggle({ ...modalToggle, modalSuccess: true }); 
      } 
    }).catch((error)=>{
      switch (error) {
        case "Drone is in uesd":
          tempErrorMessage = "โดรนที่เลือกมีการใช้งานอยู่ในช่วงเวลานี้";
          break;
        case "Pilot is busy":
          tempErrorMessage = "นักบินที่เลือกมีการปฏิบัติงานอยู่ในช่วงเวลานี้";
          break;
        case "This area is already used":
          tempErrorMessage =
            "พื้นที่ที่เลือกมีการปฏิบัติงานอยู่ในช่วงเวลานี้";
          break;
        case "The co id field is required.":
          tempErrorMessage = "โปรดเลือกนักบิน";
          break;
        case "The drone id field is required.":
          tempErrorMessage = "โปรดเลือกอากาศยาน";
          break;
        case "The purpose field is required.":
          tempErrorMessage = "โปรดเลือกวัตถุประสงค์";
          break;
        case "The operation area field is required.":
          tempErrorMessage = "โปรดเลือกพื้นที่";
          break;
        case "Dropdown data not found":
          tempErrorMessage = "โปรดเวลาใหม่เนื่องจากเวลาเริ่มต้นเกินกำหนด";
          break;
        case "Dropdown_id is not valid":
          tempErrorMessage = "กรุณาเลือกกรอกข้อมูลใหม่";
          break;
        default:
          tempErrorMessage = "";
      }
      setTextBody(tempErrorMessage);
      setModalToggle({ ...modalToggle, modalErr: true });
    })
  };

  const onEachFeature = (feature, layer) => {
    if (feature.properties && feature.properties.name) {
      layer.bindPopup(feature.properties.name);
    } else if (feature.properties && feature.properties.Ministry) {
      layer.bindPopup(feature.properties.Agency);
    } else if (feature.properties && feature.properties.name_t) {
      layer.bindPopup(feature.properties.name_t);
    }
  };

  // ██████╗░███████╗███╗░░██╗██████╗░███████╗██████╗░  ███████╗██╗░░░██╗███╗░░██╗░█████╗░████████╗██╗░█████╗░███╗░░██╗
  // ██╔══██╗██╔════╝████╗░██║██╔══██╗██╔════╝██╔══██╗  ██╔════╝██║░░░██║████╗░██║██╔══██╗╚══██╔══╝██║██╔══██╗████╗░██║
  // ██████╔╝█████╗░░██╔██╗██║██║░░██║█████╗░░██████╔╝  █████╗░░██║░░░██║██╔██╗██║██║░░╚═╝░░░██║░░░██║██║░░██║██╔██╗██║
  // ██╔══██╗██╔══╝░░██║╚████║██║░░██║██╔══╝░░██╔══██╗  ██╔══╝░░██║░░░██║██║╚████║██║░░██╗░░░██║░░░██║██║░░██║██║╚████║
  // ██║░░██║███████╗██║░╚███║██████╔╝███████╗██║░░██║  ██║░░░░░╚██████╔╝██║░╚███║╚█████╔╝░░░██║░░░██║╚█████╔╝██║░╚███║
  // ╚═╝░░╚═╝╚══════╝╚═╝░░╚══╝╚═════╝░╚══════╝╚═╝░░╚═╝  ╚═╝░░░░░░╚═════╝░╚═╝░░╚══╝░╚════╝░░░░╚═╝░░░╚═╝░╚════╝░╚═╝░░╚══╝

  function RenderSideBarWrapper({ renderContent }) {
    return (
      <div className="sidebar-wrapper">
        <div
          className="sidebar-card"
          style={{
            boxShadow: "0px 0px 0px 0px",
            backgroundColor: "white",
          }}
        >
          <div className="sidebar-card-body" style={{ height: "auto" }}>
            <div className="form-content">{renderContent}</div>
          </div>
        </div>
      </div>
    );
  }

  function RenderCreatedPolygonOnMap() {
    if (operationArea.length > 0) {
      return (
        <Polygon
          key={1}
          pathOptions={{
            color: "green",
            fillColor: "lightgreen",
            fillOpacity: 0.5,
          }}
          positions={operationArea}
        />
      );
    } else {
      return null;
    }
  }

  function RenderDroneSelection() {
    const droneOptions = [];
    for (let i = 0; i < availableDrone.length; i++) {
      if (
        typeof availableDrone[i] !== "string" ||
        !availableDrone[i].includes("-")
      ) {
        continue;
      }
      const [id, brand, name] = availableDrone[i]
        .split("-")
        .map((item) => item.trim());
      droneOptions.push(
        <option key={id} value={availableDrone[i]}>
          {`${brand}-${name}`}
        </option>
      );
    }
    return droneOptions.length > 0 ? droneOptions : null;
  }

  function RenderPurposeSelection() {
    if (typeof selectedDrone !== "string" || !selectedDrone.includes("-")) {
      return null;
    }
    const selectedDroneID = parseInt(selectedDrone.split("-")[0].trim());
    const purposeToChoose = availablePurpose[selectedDroneID];
    if (!Array.isArray(purposeToChoose)) {
      return null;
    }
    const purposeForSelection = purposeToChoose.map((id) => {
      const matchingObject = fetchedPurpose.find(
        (obj) => obj.purpose_id === id
      );
      return matchingObject
        ? { id: matchingObject.purpose_id, purpose: matchingObject.purpose }
        : null;
    });
    const purposeOptions = [];
    for (let i = 0; i < purposeForSelection.length; i++) {
      purposeOptions.push(
        <option
          key={purposeForSelection[i].id}
          value={purposeForSelection[i].id}
        >
          {purposeForSelection[i].purpose}
        </option>
      );
    }
    return purposeOptions;
  }

  function RenderPilotSelection() {
    const filteredPilots = {};
    availablePilot.forEach((item) => {
      const [id, name, type] = item.split("-");
      const idNum = parseInt(id);

      if (!filteredPilots[type]) {
        filteredPilots[type] = [];
      }
      filteredPilots[type].push({ id: idNum, name: name.trim() });
    });
    const pilotOptions = [];
    const parsedIntSelectedPurpose = parseInt(selectedPurpose);

    if (filteredPilots.SPECIFIC) {
      for (let i = 0; i < filteredPilots.SPECIFIC.length; i++) {
        pilotOptions.push(
          <option
            key={filteredPilots.SPECIFIC[i].id}
            value={filteredPilots.SPECIFIC[i].id}
          >
            {`${filteredPilots.SPECIFIC[i].name} (SPECIFIC)`}
          </option>
        );
      }
    }
    return pilotOptions.length > 0 ? pilotOptions : null;
  }

  function RenderEstimatingSuccessModal() {
    let renderDefaultCoordinate = "";
    let renderDefaultPurpose = "";
    renderDefaultCoordinate = JSON.stringify(
      normalSwapLatLon(operationArea),
      null,
      2
    )
      .replace(/\[\s+/g, "[")
      .replace(/\s+\]/g, "]")
      .replace(/\s*,\s*/g, ",");
    if (fetchedPurpose.length > 0 && selectedPurpose !== "") {
      renderDefaultPurpose = fetchedPurpose[selectedPurpose - 1].purpose;
    }

    return (
      <Modal
        size="lg"
        show={showEstimateSuccess}
        onHide={() => {
          setShowEstimateSuccess(false);
          setConfirmSend(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h3
              style={{
                color: confirmSend === true ? "green" : "grey",
                letterSpacing: "1px",
              }}
            >
              {confirmSend === true
                ? "ยืนยันการส่งคำขออนุญาติ"
                : "ร่างแบบการประเมินแผน"}
            </h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>โดรนที่ท่านเลือก</h5>
          <h6>
            {`${selectedDrone.toString().split("-")[1]}-${
              selectedDrone.toString().split("-")[2]
            }`}
          </h6>
          <h5>วัตถุประสงค์</h5>
          <h6>{renderDefaultPurpose}</h6>
          <h5>วันและเวลาเริ่มต้น</h5>
          <h6>{coopStartTime}</h6>
          <h5>วันและเวลาสิ้นสุด</h5>
          <h6>{coopEndTime}</h6>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
          <h5>พื้นที่ที่เลือก (ลองจิจูด, ละติจูด)</h5>
          <h6>{renderDefaultCoordinate}</h6>

          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "black",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          ></div>
          <div style={{ width: "100%", height: "400px" }}>
            <MapContainer
              center={operationArea[0]}
              zoom={13}
              keyboard={true}
              style={{ width: "100%", height: "100%" }}
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              <RenderCreatedPolygonOnMap />
            </MapContainer>
          </div>
          <div style={{ display: "flex" }}>
            <input
              style={{ width: "25px", height: "25px", margin: "auto 0px" }}
              type="checkbox"
              checked={confirmSend === true ? true : null}
              onChange={() => {
                if (confirmSend === false) {
                  setConfirmSend(true);
                } else {
                  setConfirmSend(false);
                }
              }}
            />
            <h4
              style={{
                fontWeight: "300",
                whiteSpace: "nowrap",
                margin: "auto 0px auto 10px",
              }}
            >
              คุณยอมรับกับข้อตกลงหรือไม่
            </h4>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            style={{
              height: "50px",
              width: "30%",
              backgroundImage:
                "linear-gradient(97.41deg, #a50104 0%, #ff792b 100%)",
            }}
            className="modal-footer30 btn-confirm"
            onClick={() => {
              setEstimateSuccessStatus({ status: null, time: null });
              setEstimateID("");
              setShowEstimateSuccess(false);
            }}
          >
            ยกเลิก
          </button>
          <button
            style={{
              height: "50px",
              width: "40%",
              backgroundImage: confirmSend
                ? "linear-gradient(97.41deg, #023E8A, #0096C7)"
                : "linear-gradient(0deg, rgba(54,54,54,1) 0%, rgba(181,181,181,1) 81%)",
              cursor: confirmSend ? "pointer" : "default",
            }}
            className="modal-footer30 btn-confirm"
            onClick={() => {
              if (confirmSend === true) {
                joinOperation();
                setShowEstimateSuccess(false);
               
              }
            }}
          >
            บันทึกแผน
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <div>
      <RenderEstimatingSuccessModal />
      <Static_modal
        modalwaiting={modalToggle.modalwait}
        modalErr={modalToggle.modalErr}
        modalSuccess={modalToggle.modalSuccess}
        modalDenied={modalToggle.modalDenied}
        textBody={textBody}
        getHandle={handleClose_Modal}
      />
      <Modal
        show={showErroroperation}
        onHide={() => setShowErroroperation(false)}
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header>
          <Modal.Title>แจ้งเตือน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ท่านยังไม่ได้ลงทะเบียนโดรน หรือ โดรนของท่านยังไม่ได้รับการอนุมัติ{" "}
        </Modal.Body>
      </Modal>
      <div
        style={{
          minHeight: "93.25vh",
          height: "auto",
          width: "auto",
          display: "flex",
        }}
      >
        <MapContainer
          center={[13.101029105523143, 100.92994760607247]}
          zoom={13}
          keyboard={true}
          style={{ width: "100%", height: "auto" }}
          ref={mapRef}
        >
          <RenderCreatedPolygonOnMap />
          <Control position="topright">
            <button
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "35px",
                width: "35px",
                backgroundColor: "white",
                borderWidth: "1px",
                borderColor: "grey",
                color: "black",
              }}
              className="btn btn-primary"
              onClick={showMyLocation}
            >
              <GoLocation />
            </button>
          </Control>
          <Control prepend position="bottomleft">
            <div
              style={{
                width: "250px",
                backgroundColor: "white",
                borderWidth: "1px",
                borderColor: "grey",
                color: "black",
              }}
            >
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: "16px", margin: "0px auto" }}>
                  <input
                    style={{
                      marginRight: "5px",
                      height: "14px",
                      width: "15px",
                    }}
                    type="checkbox"
                    checked={populationShow}
                    onChange={() => {
                      if (populationShow === false) {
                        setPopulationShow(true);
                      } else {
                        setPopulationShow(false);
                      }
                    }}
                  />
                  ข้อมูลความหนาแน่นประชากร
                </label>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: "10px",
                }}
              >
                สีของความหนาแน่นประชากร
              </div>
              <div
                style={{
                  paddingTop: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingBottom: "10px",
                }}
              >
                <table>
                  <thead>
                    <tr>
                      <th style={{ padding: "0px 10px" }}>สี</th>
                      <th style={{ padding: "0px 10px" }}>จำนวนประชากร</th>
                    </tr>
                  </thead>
                  <tbody>
                    {legendPopulation.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            color: "red",
                            opacity: item.color,
                            padding: "0px 10px",
                          }}
                        >
                          <FaCircle />
                        </td>
                        <td style={{ padding: "0px 10px" }}>
                          {item.population}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Control>
          <LayersControl position="bottomright">
            <LayersControl.BaseLayer name="Google Map">
              <TileLayer
                style={{ zIndex: 2 }}
                url="http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}"
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer checked name="OpenStreet Map">
              <TileLayer
                style={{ zIndex: 2 }}
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="OpenToPo Map">
              <TileLayer
                style={{ zIndex: 2 }}
                url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="ThunderForest Map">
              <TileLayer
                style={{ zIndex: 2 }}
                url="https://tile.thunderforest.com/landscape/{z}/{x}/{y}.png
"
              />
            </LayersControl.BaseLayer>

            <LayersControl.Overlay checked name="Aerodome area">
              {Aerodrome && (
                <GeoJSON
                  data={Aerodrome}
                  style={{
                    color: "orange",
                    fillColor: "orange",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Flight prohibitation area">
              {PDRArea && (
                <GeoJSON
                  data={PDRArea}
                  style={{
                    color: "red",
                    fillColor: "red",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Hospital area">
              {hospital && (
                <GeoJSON
                  data={hospital}
                  style={{
                    color: "purple",
                    fillColor: "purple",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Goverment Office area">
              {govOffice && (
                <GeoJSON
                  data={govOffice}
                  style={{
                    color: "blue",
                    fillColor: "blue",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Embassy area">
              {embassy && (
                <GeoJSON
                  data={embassy}
                  style={{
                    color: "yellow",
                    fillColor: "yellow",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Police department area">
              {policeDepartment && (
                <GeoJSON
                  data={policeDepartment}
                  style={{
                    color: "green",
                    fillColor: "green",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Thai Goverment area">
              {thaiGov && (
                <GeoJSON
                  data={thaiGov}
                  style={{
                    color: "red",
                    fillColor: "red",
                    fillOpacity: 1,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            {bangkokPopulation && populationShow === true ? (
              <GeoJSON
                data={bangkokPopulation}
                style={bangkokPopulationColorized}
                onEachFeature={onEachFeature}
              />
            ) : null}
          </LayersControl>
        </MapContainer>
        {sidebarMain === true ? (
          <>
            <div
              className="sidebar-main"
              style={{
                position: "relative",
                top: "0px",
                height: "auto",
                width: "30%",
                animation: "none",
              }}
            >
              <Offcanvas.Header
                className="sidebar-header"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Offcanvas.Title>
                  <h3>เข้าร่วมแผนการบิน</h3>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Tabs
                  fill
                  id="controlled-tabs"
                  defaultActiveKey={displayPlans}
                  onSelect={(event) => {
                    setDisplayPlans(parseInt(event));
                  }}
                  style={{
                    marginTop: "20px",
                    color: "#0077B6",
                    fontSize: "15px",
                    borderWidth: "5px",
                  }}
                >
                  <Tab
                    eventKey="1"
                    className="nav-link-test"
                  
                  >
                    <div className="sidebar-wrapper">
                      <div
                        className="sidebar-card"
                        style={{
                          boxShadow: "0px 0px 0px 0px",
                          backgroundColor: "white",
                        }}
                      >
                        <div
                          className="sidebar-card-body"
                          style={{ height: "auto" }}
                        >
                          <div className="form-content">
                            <div className="input-section">
                              <h5>รหัสการปฏิบัติการที่ต้องการเข้าร่วม</h5>
                              <input
                                value={operationCode}
                                min={0}
                                max={90}
                                onChange={(event) => {
                                  setOperationCode(event.target.value);
                                }}
                                style={{ width: "100%" }}
                              />
                            </div>
                            <div className="button-section">
                              <button
                                className="modal-footer30 btn-confirm"
                                style={{ width: "90%", marginTop: "-30px" }}
                                onClick={() => {
                                  findOperation();
                                }}
                              >
                                ตรวจสอบรหัสการเข้าร่วม
                              </button>
                            </div>
                            <div className="input-section">
                              <h5>เวลาเริ่มต้น</h5>
                              <input
                                defaultValue={coopStartTime}
                                readOnly
                                style={{ width: "100%" }}
                              />
                            </div>
                            <div className="input-section">
                              <h5>เวลาสิ้นสุด</h5>
                              <input
                                defaultValue={coopEndTime}
                                readOnly
                                style={{ width: "100%" }}
                              />
                            </div>
                            <div className="input-section">
                              <h5>เลือกอากาศยาน</h5>
                              <select
                                value={selectedDrone.toString()}
                                className="dropdown-field"
                                onChange={(event) => {
                                  setAvailableDroneID(
                                    parseInt(event.target.value.substring(0, 2))
                                  );
                                  setselectedDrone(event.target.value);
                                }}
                              >
                                <option value="" disabled>
                                  เลือกโดรนที่จะเข้าร่วม
                                </option>
                                <option value="">-</option>
                                <RenderDroneSelection />
                              </select>
                            </div>
                            <div className="input-section">
                              <h5>วัตถุประสงค์การบิน</h5>
                              <input
                                defaultValue={operationPurpose}
                                readOnly
                                style={{ width: "100%" }}
                              />
                            </div>
                            <div className="input-section">
                              <h5>เลือกนักบิน</h5>
                              <select
                                value={selectedPilot.toString()}
                                className="dropdown-field"
                                onChange={(event) => {
                                  setSelectedPilot(event.target.value);
                                }}
                              >
                                <option value="" disabled>
                                  เลือกนักบินที่จะเข้าร่วม
                                </option>
                                <option value="">-</option>
                                <RenderPilotSelection />
                              </select>
                            </div>
                            {/* MarkFix */}
                            {isCoopFound === true && selectedDrone !== "" && selectedPilot !== ""  ? (
                              <div className="button-section">
                                <button
                                  className="modal-footer30 btn-confirm"
                                  style={{ width: "300px", marginTop: "40px" }}
                                  onClick={() => {
                                    setShowEstimateSuccess(true);
                                  }}
                                >
                                  เข้าร่วมแผนการบิน
                                </button>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </Offcanvas.Body>
              <OverlayTrigger
                key={"right"}
                placement={"right"}
                overlay={<Tooltip id={`tooltip-${"right"}`}>Close</Tooltip>}
              >
                <div
                  className="toNavSide-btn icon-pointer"
                  style={{
                    top: "50%",
                    borderRadius: "0px 10px 10px 0px",
                    animation: "none",
                  }}
                  onClick={() => {
                    setSidebarMain(!sidebarMain);
                  }}
                >
                  <MdDoubleArrow />
                </div>
              </OverlayTrigger>
            </div>
          </>
        ) : (
          <div
            className="sidebar-main"
            style={{
              position: "relative",
              top: "0px",
              height: "auto",
              width: "1%",
              animation: "none",
            }}
          >
            <OverlayTrigger
              key={"left"}
              placement={"left"}
              overlay={<Tooltip id={`tooltip-${"left"}`}>Open</Tooltip>}
            >
              <div
                className="toNavSide-btn icon-pointer"
                style={{
                  top: "50%",
                  borderRadius: "10px 0px 0px 10px",
                  right: "0px",
                  animation: "none",
                }}
                onClick={() => {
                  setSidebarMain(!sidebarMain);
                }}
              >
                <MdDoubleArrow style={{ transform: "scaleX(-1)" }} />
              </div>
            </OverlayTrigger>
          </div>
        )}
      </div>
    </div>
  );
}

export default JoinOperation;
